import { useCallback, useRef } from 'react';
import { useFocusEffect } from 'expo-router';

/**
 * Refetch a list query every time its screen regains navigation focus: a tab
 * switch, or coming back from a detail screen. The list hooks already refetch
 * on mount, and expo-router's Tabs keep screens mounted, so without this a
 * tab visited once would not refetch on later visits.
 *
 * The first focus coincides with mount, which the query already handles, so
 * it is skipped rather than fetching twice.
 */
export function useRefetchOnFocus(refetch: () => unknown): void {
  const isFirstFocus = useRef(true);
  useFocusEffect(
    useCallback(() => {
      if (isFirstFocus.current) {
        isFirstFocus.current = false;
        return;
      }
      refetch();
    }, [refetch]),
  );
}
